export default {
  formId: 'checkoutForm',
  formField: {
    firstName: {
      name: 'firstName',
      label: 'Nome completo*',
      requiredErrorMsg: 'O nome completo é obrigatório'
    },
    email: {
      name: 'email',
      label: 'Email*',
      requiredErrorMsg: 'O email é obrigatório'
    },
    document: {
      name: 'document',
      label: 'CPF/CNPJ*',
      requiredErrorMsg: 'CPF/CNPJ é obrigatório'
    },
    address1: {
      name: 'address1',
      label: 'Endereço*',
      requiredErrorMsg: 'O Endereço é obrigatório'
    },
    city: {
      name: 'city',
      label: 'Cidade*',
      requiredErrorMsg: 'Cidade é obrigatória'
    },
    state: {
      name: 'state',
      label: 'Estado*',
      requiredErrorMsg: 'Estado é obrigatório'
    },
    zipcode: {
      name: 'zipcode',
      label: 'CEP*', // ✅ CORRIGIDO: Era "CPF/CNPJ*"
      requiredErrorMsg: 'CEP é obrigatório',
      invalidErrorMsg: 'Formato de CEP inválido'
    },
    country: {
      name: 'country',
      label: 'País*',
      requiredErrorMsg: 'País é obrigatório'
    },
    useAddressForPaymentDetails: {
      name: 'useAddressForPaymentDetails',
      label: 'Use this address for payment details'
    },
    nameOnCard: {
      name: 'nameOnCard',
      label: 'Nome no cartão*',
      requiredErrorMsg: 'Nome no cartão é obrigatório'
    },
    cardNumber: {
      name: 'cardNumber',
      label: 'Número do cartão*',
      requiredErrorMsg: 'Número do cartão é obrigatório',
      invalidErrorMsg: 'Número do cartão não é válido'
    },
    expiryDate: {
      name: 'expiryDate',
      label: 'Data de validade*',
      requiredErrorMsg: 'Data de validade é obrigatória',
      invalidErrorMsg: 'Data de validade não é válida'
    },
    cvv: {
      name: 'cvv',
      label: 'CVV*',
      requiredErrorMsg: 'CVV é obrigatório',
      invalidErrorMsg: 'CVV é inválido'
    }
  }
};